<template>
    <div class="d-flex justify-content-center align-items-center">
        <form v-on:keyup.enter="checkThenSend" class="editForm shadow">
            Changer son mot de passe <br>
            <div>
                <div>
                    <input type="password" placeholder="Mot de passe" v-model="password">
                </div>
                <div>
                    <input type="password" placeholder="Nouveau mot de passe" v-model="newPassword">
                </div>
                <div>
                    <input type="password" placeholder="Confirmer mot de passe" v-model="confirmedPassword">
                </div>
            </div>
            <div class="error row" v-if="errors.length">
                <ul>
                    <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
                </ul>
            </div>
            <div v-if="!pending" class="btn row btn-outline-success" v-on:click="checkThenSend">Modifier</div>
        </form>
    </div>
</template>

<script>

    const axios = require('axios');

    export default {
        name: "EditPassword",
        data() {
            return {
                pending: false,
                errors: [],
                password: '',
                newPassword: '',
                confirmedPassword: '',
            }
        },
        methods: {
            resetData: function() {
                this.password = '';
                this.newPassword = '';
                this.confirmedPassword = '';
            },
            sendUpdate: function() {
                var data = {
                    password: this.password,
                    newPassword: this.newPassword,
                };

                axios.put(this.$store.state.apiUrl + 'user/updatePassword/' + localStorage.id, data, {
                        params: {
                            login: localStorage.login,
                            password: localStorage.pass
                        }
                    })
                    .then(response => (this.checkResponse(response)))
                    .catch((e) => {
                        this.printError(e);
                    });
            },
            checkThenSend: function() {
                this.errors = [];
                this.pending = true;
                if (!this.password){
                    this.errors.push("Le champ mot de passe est vide");
                    this.pending = false;
                }
                if (!this.newPassword ){
                    this.errors.push("Veuillez renseinger un nouveau mot de passe")
                    this.pending = false;
                }else if (this.newPassword != this.confirmedPassword) {
                    this.errors.push("La confirmation a échoué")
                    this.confirmedPassword = '',
                    this.pending = false;
                } 
                if(this.errors.length == 0){
                    this.sendUpdate();
                }
            },
            checkResponse: function(response) {
                this.errors=[];
                this.resetData();
                
                if (response.status == 200) {
                    this.printSuccess();
                } else if(response.status == 203){
                    this.errors.push('Mauvais mot de passe')
                }
                
                this.pending = false;
            },
            printError: function(e) {
                console.log(e);
                this.$toasted.show("Erreur de connexion, veuillez essayer ultérieurement", {
                    position: 'bottom-center',
                    theme: 'outline'
                }).goAway(2000);
                this.pending = false;
            },
            printSuccess: function() {
                this.$toasted.show("Mot de passe modifié", {
                    position: 'bottom-center',
                    theme: 'outline'
                }).goAway(2000);
            }
        }
    };
</script>

<style scoped>
    #banner {
        width: 100%;
        display: table;
    }

    #banner img {
        margin-bottom: 4%;
        height: 10em;
    }

    #banner span {
        font-weight: bold;
        font-size: 28px;
        text-align: left;
        height: 100%;
        line-height: 26px;
        vertical-align: middle;
        display: table-cell;
        padding: .35em;
    }

    form {
        margin: auto;
        text-align: center;
        display: inline-block;
        padding: 2em;
    }

    form input {
        border: 1px solid #ced4da;
        border-radius: .25rem;
        margin-bottom: 1.5em;
        padding: 4px;
    }

    form input,
    .btn {
        width: 90%;
    }

    .btn {
        margin-top: 1.8em;
    }

    ul {
        list-style: none;
        padding-inline-start: 0px;
    }

    .error {
        display: block;
        color: red;
        text-align: center;
    }
</style>